import {
  ComponentLabel,
  FieldAttribute,
  UiZoneWidgetConfig,
  WidgetNames,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const mapLineWidgetFunction = function mapLineWidget(item: WorkflowWidgetConfig): UiZoneWidgetConfig {
  const elementsConfig = item.widgetConfiguration.attributes?.elementsConfig;

  const fieldAttribute = (
    item.widgetConfiguration?.attributes?.['field_attributes'] as FieldAttribute[]
  ).find((addConfig: { name: string }) => addConfig?.name === WidgetNames.LINE_WIDGET);

  return {
    name: item.name as ComponentLabel,
    attributes: {
      ...item.widgetConfiguration.attributes,
      showlineWidget:
        elementsConfig.find((item) => item.field_name === WidgetNames.LINE_WIDGET)?.show ?? true,
      ...(fieldAttribute?.additional_config as FieldAttribute),
    },
    uniqueId: item.uniqueId,
    gridPosition: item.gridPosition,
  };
};
